import repository from '../../plugins/repository';

const resource = "/Meta";

export default {
    findAll() {
        return repository.get(`${resource}`);
    },
};